import React from 'react';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { FiltersProvider } from '@context';
import { ManageWorkers } from '@components/templates/myAccount/manageWorkers';

export function ManageWorkersPage() {
    const { store } = useParams();
    const { t } = useTranslation();

    const translations = {
        title: t('manage-workers-component.metatags.title'),
        description: t('manage-workers-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.myWorkers.replace(':store', `${store}`),
        index: false,
    });

    return (
        <FiltersProvider>
            <ManageWorkers />
        </FiltersProvider>
    );
}
